import React from 'react';
import { Redirect, Route } from 'react-router-dom';
import { toast } from 'sonner';

import { useAuthDataContext } from 'components/AuthDataProvider/AuthDataProvider';
import LoadingIndicator from 'components/LoadingIndicator/LoadingIndicator';

const UnauthorizedPublicRouteRedirect = ({ to }) => {
  React.useEffect(() => {
    toast.warning('This page is not available to your user. Please log out to continue.', { duration: 15000 });
  }, []);

  return <Redirect to={to} />;
};

export default ({
  component: Component, restricted, allowedRoles, ...rest
}) => {
  const { isAuthLoaded, user, DASHBOARD_ROUTE } = useAuthDataContext();

  // Scroll to top when navigating to page for the first time
  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  if (!isAuthLoaded) {
    return (<LoadingIndicator />);
  }

  return (
    <Route
      {...rest}
      render={(props) => (
        user && restricted
          ? <Redirect to={DASHBOARD_ROUTE} />
          : user && allowedRoles?.length > 0 && !allowedRoles.includes(user.role)
            ? <UnauthorizedPublicRouteRedirect to={DASHBOARD_ROUTE} />
            : <Component {...props} {...rest} />
      )}
    />
  );
};
